var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _path2, _rect8, _rect9, _rect10, _rect11, _rect12, _path3, _path4, _path5, _rect13, _g, _g2, _g3, _g4, _g5, _g6, _rect14, _path6, _rect15, _rect16, _path7, _rect17, _rect18, _path8, _rect19, _path9, _path10, _path11, _path12, _path13, _rect20, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g7, _g8, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _g9, _path52, _g10, _g11, _path53, _path54, _g12, _path55, _path56, _g13, _path57, _g14, _path58, _g15, _path59, _path60, _path61, _path62;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRefused = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "DECLINE",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 372.56,
    viewBox: "0 0 500 372.56",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9406",
    "data-name": "Ret\\xE2ngulo 9406",
    width: 500,
    height: 372.56,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9383",
    "data-name": "Ret\\xE2ngulo 9383",
    width: 292.35,
    height: 6.89,
    transform: "translate(106.57 29.71)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9384",
    "data-name": "Ret\\xE2ngulo 9384",
    width: 292.35,
    height: 6.89,
    transform: "translate(106.57 41)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9385",
    "data-name": "Ret\\xE2ngulo 9385",
    width: 292.35,
    height: 6.89,
    transform: "translate(106.57 52.3)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9386",
    "data-name": "Ret\\xE2ngulo 9386",
    width: 292.35,
    height: 6.89,
    transform: "translate(106.57 63.59)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9387",
    "data-name": "Ret\\xE2ngulo 9387",
    width: 292.35,
    height: 6.89,
    transform: "translate(106.57 74.89)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9388",
    "data-name": "Ret\\xE2ngulo 9388",
    width: 292.35,
    height: 6.89,
    transform: "translate(106.57 86.18)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9396",
    "data-name": "Ret\\xE2ngulo 9396",
    width: 118.088,
    height: 114.472,
    transform: "translate(174.564 138.821)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9397",
    "data-name": "Ret\\xE2ngulo 9397",
    width: 74.155,
    height: 69.897,
    transform: "translate(92.831 147.147)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9398",
    "data-name": "Ret\\xE2ngulo 9398",
    width: 9.66,
    height: 18.49,
    transform: "translate(376.57 92.88)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9399",
    "data-name": "Ret\\xE2ngulo 9399",
    width: 13,
    height: 5.56,
    transform: "translate(339.21 100.31)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9400",
    "data-name": "Ret\\xE2ngulo 9400",
    width: 60.34,
    height: 16.63,
    transform: "translate(345.69 328.43)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9401",
    "data-name": "Ret\\xE2ngulo 9401",
    width: 16.41,
    height: 7.19,
    transform: "translate(349.12 66.74)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9402",
    "data-name": "Ret\\xE2ngulo 9402",
    width: 52.18,
    height: 185.35,
    transform: "translate(355.77 152.4)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9403",
    "data-name": "Ret\\xE2ngulo 9403",
    width: 9.845,
    height: 60.605,
    transform: "translate(358.28 173.815)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9404",
    "data-name": "Ret\\xE2ngulo 9404",
    width: 31.191,
    height: 190.1,
    transform: "translate(337.359 152.39)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13687",
    "data-name": "Grupo 13687",
    clipPath: "url(#clip-path)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9370",
    "data-name": "Ret\\xE2ngulo 9370",
    width: 500,
    height: 0.25,
    transform: "translate(0 327.4)",
    fill: "#ebebeb"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9371",
    "data-name": "Ret\\xE2ngulo 9371",
    width: 33.12,
    height: 0.25,
    transform: "translate(416.78 343.49)",
    fill: "#ebebeb"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9372",
    "data-name": "Ret\\xE2ngulo 9372",
    width: 8.69,
    height: 0.25,
    transform: "translate(322.53 346.21)",
    fill: "#ebebeb"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9373",
    "data-name": "Ret\\xE2ngulo 9373",
    width: 19.19,
    height: 0.25,
    transform: "translate(396.59 334.21)",
    fill: "#ebebeb"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9374",
    "data-name": "Ret\\xE2ngulo 9374",
    width: 43.19,
    height: 0.249,
    transform: "translate(52.46 335.891)",
    fill: "#ebebeb"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9375",
    "data-name": "Ret\\xE2ngulo 9375",
    width: 6.33,
    height: 0.249,
    transform: "translate(104.56 335.891)",
    fill: "#ebebeb"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9376",
    "data-name": "Ret\\xE2ngulo 9376",
    width: 93.68,
    height: 0.25,
    transform: "translate(131.47 340.11)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13686",
    "data-name": "Grupo 13686"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13685",
    "data-name": "Grupo 13685",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7750",
    "data-name": "Caminho 7750",
    d: "M237,282.8H43.91a5.71,5.71,0,0,1-5.7-5.71V5.66A5.71,5.71,0,0,1,43.91,0H237a5.709,5.709,0,0,1,5.71,5.71V277.09A5.709,5.709,0,0,1,237,282.8M43.91.2a5.459,5.459,0,0,0-5.45,5.46V277.09a5.46,5.46,0,0,0,5.45,5.46H237a5.471,5.471,0,0,0,5.46-5.46V5.66A5.47,5.47,0,0,0,237,.2Z",
    fill: "#ebebeb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7751",
    "data-name": "Caminho 7751",
    d: "M453.31,282.8H260.21a5.721,5.721,0,0,1-5.71-5.71V5.66A5.72,5.72,0,0,1,260.21,0h193.1A5.71,5.71,0,0,1,459,5.66V277.09a5.71,5.71,0,0,1-5.69,5.71M260.21.2a5.47,5.47,0,0,0-5.46,5.46V277.09a5.471,5.471,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V5.66A5.47,5.47,0,0,0,453.31.2Z",
    fill: "#ebebeb"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9377",
    "data-name": "Ret\\xE2ngulo 9377",
    width: 291.79,
    height: 136.52,
    transform: "translate(101.29 21.16)",
    fill: "#e6e6e6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9378",
    "data-name": "Ret\\xE2ngulo 9378",
    width: 294.13,
    height: 136.52,
    transform: "translate(103.34 21.16)",
    fill: "#f0f0f0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9379",
    "data-name": "Ret\\xE2ngulo 9379",
    width: 291.79,
    height: 6.96,
    transform: "translate(101.29 157.68)",
    fill: "#e6e6e6"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9380",
    "data-name": "Ret\\xE2ngulo 9380",
    width: 294.13,
    height: 6.96,
    transform: "translate(110.66 157.68)",
    fill: "#f0f0f0"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9381",
    "data-name": "Ret\\xE2ngulo 9381",
    width: 281.82,
    height: 124.21,
    transform: "translate(109.5 27.32)",
    fill: "#fafafa"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7752",
    "data-name": "Caminho 7752",
    d: "M139.73,151.53,156.86,27.32h26.73L166.46,151.53Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7753",
    "data-name": "Caminho 7753",
    d: "M112.34,145.4a.44.44,0,0,1-.44-.44V31.32a.44.44,0,1,1,.88,0V145a.43.43,0,0,1-.44.4",
    fill: "#f0f0f0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7754",
    "data-name": "Caminho 7754",
    d: "M172.2,151.53,189.33,27.32h10.42L182.62,151.53Z",
    fill: "#fff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9382",
    "data-name": "Ret\\xE2ngulo 9382",
    width: 0.78,
    height: 124.21,
    transform: "translate(390.54 27.32)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13642",
    "data-name": "Grupo 13642",
    opacity: 0.6,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13641",
    "data-name": "Grupo 13641"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13640",
    "data-name": "Grupo 13640",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7755",
    "data-name": "Caminho 7755",
    d: "M398.92,36.6H107.14l-.57-6.89H398.36Z",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13645",
    "data-name": "Grupo 13645",
    opacity: 0.6,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13644",
    "data-name": "Grupo 13644"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13643",
    "data-name": "Grupo 13643",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7756",
    "data-name": "Caminho 7756",
    d: "M398.92,47.89H107.14L106.57,41H398.36Z",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13648",
    "data-name": "Grupo 13648",
    opacity: 0.6,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13647",
    "data-name": "Grupo 13647"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13646",
    "data-name": "Grupo 13646",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7757",
    "data-name": "Caminho 7757",
    d: "M398.92,59.19H107.14l-.57-6.89H398.36Z",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13651",
    "data-name": "Grupo 13651",
    opacity: 0.6,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13650",
    "data-name": "Grupo 13650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13649",
    "data-name": "Grupo 13649",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7758",
    "data-name": "Caminho 7758",
    d: "M398.92,70.48H107.14l-.57-6.89H398.36Z",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13654",
    "data-name": "Grupo 13654",
    opacity: 0.6,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13653",
    "data-name": "Grupo 13653"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13652",
    "data-name": "Grupo 13652",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7759",
    "data-name": "Caminho 7759",
    d: "M398.92,81.78H107.14l-.57-6.89H398.36Z",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13657",
    "data-name": "Grupo 13657",
    opacity: 0.6,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13656",
    "data-name": "Grupo 13656"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13655",
    "data-name": "Grupo 13655",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7760",
    "data-name": "Caminho 7760",
    d: "M398.92,93.07H107.14l-.57-6.89H398.36Z",
    fill: "#ebebeb"
  }))))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9389",
    "data-name": "Ret\\xE2ngulo 9389",
    width: 44.53,
    height: 135.4,
    transform: "translate(394.47 192)",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7761",
    "data-name": "Caminho 7761",
    d: "M427.11,327.4H439V308.71H414.64Z",
    fill: "#fafafa"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9390",
    "data-name": "Ret\\xE2ngulo 9390",
    width: 44.53,
    height: 135.4,
    transform: "translate(273.06 192)",
    fill: "#e6e6e6"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9391",
    "data-name": "Ret\\xE2ngulo 9391",
    width: 131.79,
    height: 128.97,
    transform: "translate(307.21 192)",
    fill: "#fafafa"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7762",
    "data-name": "Caminho 7762",
    d: "M319.1,327.4H307.21V308.71h24.36Z",
    fill: "#fafafa"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9392",
    "data-name": "Ret\\xE2ngulo 9392",
    width: 113.34,
    height: 32.27,
    transform: "translate(316.43 240.06)",
    fill: "#f0f0f0"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9393",
    "data-name": "Ret\\xE2ngulo 9393",
    width: 113.34,
    height: 32.27,
    transform: "translate(316.43 279.23)",
    fill: "#f0f0f0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7763",
    "data-name": "Caminho 7763",
    d: "M334.24,237.26H412v1.57a4.67,4.67,0,0,1-4.67,4.67H338.92a4.67,4.67,0,0,1-4.67-4.67v-1.57Z",
    fill: "#fafafa"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9394",
    "data-name": "Ret\\xE2ngulo 9394",
    width: 113.34,
    height: 32.27,
    transform: "translate(316.43 200.88)",
    fill: "#f0f0f0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7764",
    "data-name": "Caminho 7764",
    d: "M334.24,198.09H412v1.57a4.67,4.67,0,0,1-4.67,4.67H338.92a4.67,4.67,0,0,1-4.67-4.67v-1.57Z",
    fill: "#fafafa"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7765",
    "data-name": "Caminho 7765",
    d: "M334.24,276.43H412V278a4.67,4.67,0,0,1-4.67,4.67H338.92a4.67,4.67,0,0,1-4.67-4.67v-1.57Z",
    fill: "#fafafa"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7766",
    "data-name": "Caminho 7766",
    d: "M53.42,220.87c2.48-7.13,22,2.56,30,14.36,5.29,7.86,8.52,16.25,10,27.52-.18-12.86-.38-26.67-.58-39.71-1.61-3.25-5.28-10.75-7.91-16.69-8.8-19.82-29.72-27.2-37-39.71-9.47-16.4-9.41-41-1.35-49.86,7-7.72,30.2,44.43,32.82,50.26,9,20,11.6,34.91,13.28,49.32-.19-12.25-.37-23.49-.52-32.17-.49-28.3-1.11-37.4-1.39-40.2-1-1.37-2.11-3-2.78-3.82-5.61-7.23-18.07-15.83-24.29-26.34-9.09-15.34-7.62-33.7-1.25-40.54C69.17,66.14,81,83,87.21,99.78s3.58,32.76,5.34,46.67c.37,2.72.74,13.08,1.1,27.45,1.9-15.46,5.68-25.82,12.68-35.47,8.62-11.87,16.06-26.32,23.16-24.45s3.28,21-2.34,34.42c-5,11.95-29.68,23.88-33.32,33.49.43,19.48.81,44.15,1.09,67.12,1.94-11.87.6-12.86,8.58-31,4.74-10.8,24.17-24.11,26.49-16.69s-1.21,21.44-8.54,31.26c-5.92,7.93-19,7.92-22.09,12.83-.71,1.15-3,5.55-4.39,8.07.31,28.05.46,52.8.3,61.24l-1.28.09c.07-2.18-.09-16.45-.34-35.33-3.19-10-24.65-15.9-31.28-26.35-6.94-10.96-11.93-23.72-8.95-32.26",
    fill: "#e6e6e6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7767",
    "data-name": "Caminho 7767",
    d: "M73.6,327.4h41.2a4.74,4.74,0,0,0,4.64-3.79l2.92-14.42H66l3,14.42a4.74,4.74,0,0,0,4.6,3.79",
    fill: "#f0f0f0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7768",
    "data-name": "Caminho 7768",
    d: "M64.86,314.78h58.68a2.77,2.77,0,0,0,2.75-2.46l1.2-10.66a2.77,2.77,0,0,0-2.454-3.054,2.926,2.926,0,0,0-.3-.016H63.66a2.77,2.77,0,0,0-2.766,2.774,2.655,2.655,0,0,0,.016.3l1.2,10.66a2.77,2.77,0,0,0,2.75,2.46",
    fill: "#f0f0f0"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9395",
    "data-name": "Ret\\xE2ngulo 9395",
    width: 35.21,
    height: 64.78,
    transform: "translate(142.63 262.62)",
    fill: "#e0e0e0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7769",
    "data-name": "Caminho 7769",
    d: "M267.58,327.4H149.69L137.3,239.5H255.19Z",
    fill: "#e6e6e6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7770",
    "data-name": "Caminho 7770",
    d: "M284.78,327.4H154.37l-12.38-87.9h130.4Z",
    fill: "#f0f0f0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7771",
    "data-name": "Caminho 7771",
    d: "M167.13,313.66,156.7,253.24H259.63l10.43,60.42Z",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7772",
    "data-name": "Caminho 7772",
    d: "M211.36,313.66l-34.98-60.42h10.97l34.99,60.42Z",
    fill: "#fafafa"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7773",
    "data-name": "Caminho 7773",
    d: "M226.99,313.66,192,253.24h18.72l34.98,60.42Z",
    fill: "#fafafa"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7774",
    "data-name": "Caminho 7774",
    d: "M250,349.92c107.082,0,193.89,5.068,193.89,11.32S357.082,372.56,250,372.56,56.11,367.492,56.11,361.24,142.918,349.92,250,349.92",
    fill: "#f5f5f5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7775",
    "data-name": "Caminho 7775",
    d: "M77.27,166.53a.43.43,0,0,1-.43-.39l-2.22-26.7A.42.42,0,0,1,75,139a.43.43,0,0,1,.46.39l2.22,26.7a.43.43,0,0,1-.39.46Z",
    fill: "#fdbb4e"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7776",
    "data-name": "Caminho 7776",
    d: "M78.59,182.39a.43.43,0,0,1-.43-.39l-.67-8.08a.42.42,0,0,1,.377-.459h.013a.42.42,0,0,1,.459.377v.013l.67,8.08a.43.43,0,0,1-.39.46Z",
    fill: "#fdbb4e"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7777",
    "data-name": "Caminho 7777",
    d: "M303.56,258.37H97.08a10.63,10.63,0,0,1-10.37-9.58L75.08,109a8.7,8.7,0,0,1,8.78-9.58H290.33A10.64,10.64,0,0,1,300.71,109l11.63,139.77a8.71,8.71,0,0,1-7.774,9.555,8.892,8.892,0,0,1-1.006.045",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7778",
    "data-name": "Caminho 7778",
    d: "M303.56,258.77H97.08a11,11,0,0,1-10.77-9.94L74.68,109.05A9.2,9.2,0,0,1,77.05,102a9.1,9.1,0,0,1,6.81-3H290.33a11,11,0,0,1,10.78,10l11.62,139.77a9.09,9.09,0,0,1-8.133,9.955A8.982,8.982,0,0,1,303.56,258.77ZM83.86,99.84A8.3,8.3,0,0,0,75.426,108a8.49,8.49,0,0,0,.044,1L87.1,248.76a10.22,10.22,0,0,0,10,9.21H303.56a8.3,8.3,0,0,0,8.422-8.176,8.165,8.165,0,0,0-.042-.964L300.31,109.05a10.21,10.21,0,0,0-10-9.21Z",
    fill: "#fdbb4e"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7779",
    "data-name": "Caminho 7779",
    d: "M290.33,99.44H83.86a8.7,8.7,0,0,0-8.822,8.576,8.973,8.973,0,0,0,.042.984H300.71a10.64,10.64,0,0,0-10.38-9.56",
    fill: "#fdbb4e"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7780",
    "data-name": "Caminho 7780",
    d: "M88.69,104.23a1.87,1.87,0,0,1-1.659,2.06,1.985,1.985,0,0,1-.231.01,2.3,2.3,0,0,1-2.24-2.07,1.879,1.879,0,0,1,1.68-2.06,1.64,1.64,0,0,1,.21-.01,2.281,2.281,0,0,1,2.24,2.07",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7781",
    "data-name": "Caminho 7781",
    d: "M97.09,104.23a1.87,1.87,0,0,1-1.659,2.06,1.985,1.985,0,0,1-.231.01,2.3,2.3,0,0,1-2.2-2.07,1.879,1.879,0,0,1,1.68-2.06,1.64,1.64,0,0,1,.21-.01,2.28,2.28,0,0,1,2.2,2.07",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7782",
    "data-name": "Caminho 7782",
    d: "M105.49,104.23a1.87,1.87,0,0,1-1.659,2.06,1.985,1.985,0,0,1-.231.01,2.3,2.3,0,0,1-2.24-2.07,1.879,1.879,0,0,1,1.68-2.06,1.64,1.64,0,0,1,.21-.01,2.281,2.281,0,0,1,2.24,2.07",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7783",
    "data-name": "Caminho 7783",
    d: "M285.64,240.05H112a8.45,8.45,0,0,1-8.25-7.61L95.59,135a6.919,6.919,0,0,1,6.194-7.576,7,7,0,0,1,.806-.034H276.26a8.45,8.45,0,0,1,8.25,7.61l8.11,97.49a6.92,6.92,0,0,1-6.25,7.531,7.106,7.106,0,0,1-.73.029",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13660",
    "data-name": "Grupo 13660",
    opacity: 0.1,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13659",
    "data-name": "Grupo 13659"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13658",
    "data-name": "Grupo 13658",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7784",
    "data-name": "Caminho 7784",
    d: "M231.92,144.41l-53.8,64.78a15.39,15.39,0,0,0,8.58,24.88L274,252.94a15.39,15.39,0,0,0,17.55-20.76l-33.47-83.66a15.39,15.39,0,0,0-26.16-4.11",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13663",
    "data-name": "Grupo 13663",
    opacity: 0.1,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13662",
    "data-name": "Grupo 13662"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13661",
    "data-name": "Grupo 13661",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7785",
    "data-name": "Caminho 7785",
    d: "M112.16,153.49,93.42,204a9.72,9.72,0,0,0,10.06,13l54.73-5.37a9.72,9.72,0,0,0,6.65-15.74l-36-45.1a9.72,9.72,0,0,0-16.7,2.7",
    fill: "#263238"
  }))))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7786",
    "data-name": "Caminho 7786",
    d: "M250.48,128.1l-50.3,73a16.18,16.18,0,0,0,11.2,25.22l92.46,12.31a16.179,16.179,0,0,0,16.64-23.21l-42.16-85.34a16.181,16.181,0,0,0-27.84-1.98",
    fill: "#fdbb4e"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7787",
    "data-name": "Caminho 7787",
    d: "M213.57,219.8a10.22,10.22,0,0,1-7.82-5.67,9,9,0,0,1,.47-9.2l50.43-73.22a8.48,8.48,0,0,1,8.29-3.52,10.2,10.2,0,0,1,7.82,5.67L315,219.41a9,9,0,0,1-.47,9.2,8.469,8.469,0,0,1-8.29,3.53Z",
    fill: "#fff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7788",
    "data-name": "Caminho 7788",
    d: "M260.65,154.07l5.89.78a7.57,7.57,0,0,1,6.51,7.7l-.4,7.68a5.786,5.786,0,0,1-.09.83l-4.19,23.15a6.23,6.23,0,0,1-7.11,5,7.61,7.61,0,0,1-6.51-6.87l-1.69-23.92a5.747,5.747,0,0,1,0-.83l.39-7.69a6.209,6.209,0,0,1,6.5-5.9,6.046,6.046,0,0,1,.7.073m-.47,51.56,1.6.21a6.78,6.78,0,0,1,5.83,6.89,5.57,5.57,0,0,1-5.814,5.315,5.436,5.436,0,0,1-.636-.065l-1.6-.22a6.771,6.771,0,0,1-5.83-6.88,5.564,5.564,0,0,1,6.45-5.25",
    fill: "#fdbb4e"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7789",
    "data-name": "Caminho 7789",
    d: "M131.5,139.26l-13.81,52.37a9.72,9.72,0,0,0,11.27,12l53.57-10.45A9.72,9.72,0,0,0,187.72,177L148,135.05a9.73,9.73,0,0,0-16.5,4.21",
    fill: "#fdbb4e"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7790",
    "data-name": "Caminho 7790",
    d: "M128.85,199.41a5.93,5.93,0,0,1-5.42-1.82,5.81,5.81,0,0,1-1.5-5.48l13.84-52.51a5,5,0,0,1,3.92-3.65,5.941,5.941,0,0,1,5.42,1.83l39.86,42a5.818,5.818,0,0,1,1.51,5.48,5,5,0,0,1-3.92,3.64Z",
    fill: "#fff"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7791",
    "data-name": "Caminho 7791",
    d: "M142.29,151.93l3.41-.67a4.52,4.52,0,0,1,5.08,3.27L152,159.1a4.677,4.677,0,0,1,.11.51L154.28,174a3.73,3.73,0,0,1-3,4.31,4.5,4.5,0,0,1-4.92-2.78l-5.54-13.68a4,4,0,0,1-.17-.49l-1.26-4.58a3.76,3.76,0,0,1,2.427-4.731,3.679,3.679,0,0,1,.473-.119m9.65,30.28.93-.18a4,4,0,0,1,4.55,2.92,3.36,3.36,0,0,1-2.2,4.21,3.639,3.639,0,0,1-.356.09l-.93.18a4,4,0,0,1-4.55-2.91,3.369,3.369,0,0,1,2.212-4.221A3.227,3.227,0,0,1,151.94,182.21Z",
    fill: "#fdbb4e"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7792",
    "data-name": "Caminho 7792",
    d: "M388.36,151l-7.76,2.52,6.24,7.38a23.655,23.655,0,0,0,4.55-5.31,2.47,2.47,0,0,0-.88-3.35Z",
    fill: "#1ed6bb"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7793",
    "data-name": "Caminho 7793",
    d: "M377.03,159.62l4.65,5.65,5.17-4.33-6.25-7.38Z",
    fill: "#1ed6bb"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7794",
    "data-name": "Caminho 7794",
    d: "M390.87,90.68c1.89,5.2,3.63,10.4,5.28,15.67s3.17,10.56,4.5,16.1l.47,2.13.22,1.11.11.56v.35l.06.42a17.521,17.521,0,0,1-.28,5.7,41.9,41.9,0,0,1-2.88,8.72,82.046,82.046,0,0,1-8.56,14.8l-5.19-2.87c1.84-5,3.66-10.11,5-15.06a42.246,42.246,0,0,0,1.38-7.09,8.39,8.39,0,0,0-.12-2.48l-.43-1.56-.56-1.85c-1.57-5-3.36-10.15-5.13-15.27s-3.54-10.29-5.24-15.42Z",
    fill: "#1ed6bb"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7795",
    "data-name": "Caminho 7795",
    d: "M347.68,59.74c.13.63-.09,1.21-.49,1.32s-.84-.33-1-1,.08-1.21.49-1.31.87.37,1,.99",
    fill: "#263238"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7796",
    "data-name": "Caminho 7796",
    d: "M347.65,60.94a24.21,24.21,0,0,1-1.82,6.07,3.578,3.578,0,0,0,3.06-.18Z",
    fill: "#630f0f"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7797",
    "data-name": "Caminho 7797",
    d: "M346,56a.381.381,0,0,1-.31-.16.37.37,0,0,1,.085-.516l.005,0a3.7,3.7,0,0,1,3.39-.26.37.37,0,0,1,.2.482l0,.008a.38.38,0,0,1-.49.21,2.9,2.9,0,0,0-2.67.17A.327.327,0,0,1,346,56",
    fill: "#263238"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7798",
    "data-name": "Caminho 7798",
    d: "M369.11,61.72c.7,7.26-.33,14.29,1.29,20.6,0,0-1.8,5.86-12.53,5.86-11.8,0-5.41-5.86-5.41-5.86,6.5-1.53,6.51-6.31,5.57-10.8Z",
    fill: "#1ed6bb"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7799",
    "data-name": "Caminho 7799",
    d: "M372.69,84.33c.92-1.85,1.53-4.48-.37-5.14-2.09-.73-13.26-1-17.31.4a4.28,4.28,0,0,0-3.07,5.13Z",
    fill: "#263238"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7800",
    "data-name": "Caminho 7800",
    d: "M396.8,347.69a9.765,9.765,0,0,0,2.12-.82.211.211,0,0,0,.12-.19.19.19,0,0,0-.14-.18c-.35-.12-3.45-1.15-4.27-.45a.66.66,0,0,0-.21.64,1.231,1.231,0,0,0,.66,1,2.627,2.627,0,0,0,1.72,0m1.48-1c-1.36.62-2.46.83-3,.55a.792.792,0,0,1-.44-.66.241.241,0,0,1,.07-.26c.41-.32,2.09.03,3.37.41Z",
    fill: "#fdbb4e"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7801",
    "data-name": "Caminho 7801",
    d: "M398.88,346.89a.21.21,0,0,0,.151-.256v0c0-.1-.81-2.48-2-3a1.121,1.121,0,0,0-.91-.06.66.66,0,0,0-.51.67c0,1,2.16,2.42,3.14,2.69Zm-2.5-3a.739.739,0,0,1,.5.06,4.932,4.932,0,0,1,1.61,2.4c-1-.45-2.42-1.59-2.44-2.17,0-.05,0-.17.24-.27Z",
    fill: "#fdbb4e"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7802",
    "data-name": "Caminho 7802",
    d: "M342.18,353.8a10.414,10.414,0,0,0,2.25-.31.206.206,0,0,0,.06-.38c-.31-.19-3.09-1.9-4.05-1.41a.64.64,0,0,0-.35.58,1.259,1.259,0,0,0,.42,1.08,2.7,2.7,0,0,0,1.67.44m1.66-.6c-1.46.29-2.59.24-3.06-.16a.819.819,0,0,1-.28-.74.228.228,0,0,1,.13-.24C341.12,351.81,342.71,352.54,343.84,353.2Z",
    fill: "#fdbb4e"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7803",
    "data-name": "Caminho 7803",
    d: "M344.38,353.49a.27.27,0,0,0,.12,0,.222.222,0,0,0,.09-.19c0-.1-.22-2.59-1.22-3.41a1.083,1.083,0,0,0-.87-.26.66.66,0,0,0-.65.53c-.18,1,1.54,2.85,2.44,3.34ZM342.64,350a.7.7,0,0,1,.47.17,4.889,4.889,0,0,1,1,2.71c-.89-.68-2-2.1-1.88-2.67,0,0,0-.18.3-.21h.11Z",
    fill: "#fdbb4e"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7804",
    "data-name": "Caminho 7804",
    d: "M353.67,353.18h-7.9l-.08-18.28h7.9Z",
    fill: "#1ed6bb"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7805",
    "data-name": "Caminho 7805",
    d: "M408.66,346.42l-7.6,1.39-5.45-17.99,7.6-1.39Z",
    fill: "#1ed6bb"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7806",
    "data-name": "Caminho 7806",
    d: "M399.62,345.79l8.63-2a.66.66,0,0,1,.76.37l2.86,6.53a1.211,1.211,0,0,1-.646,1.585,1.307,1.307,0,0,1-.2.065c-3,.66-4.52.82-8.32,1.72-2.33.55-7.09,1.94-10.32,2.7s-4.27-2.36-3-3c5.66-2.71,7.54-5,9.09-7.2a2,2,0,0,1,1.15-.77",
    fill: "#263238"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7807",
    "data-name": "Caminho 7807",
    d: "M345.86,352.26h8.62a.66.66,0,0,1,.65.54l1.29,7a1.189,1.189,0,0,1-.961,1.381,1.175,1.175,0,0,1-.229.019c-3.11-.05-7.59-.23-11.5-.23-4.57,0-6.2.25-11.56.25-3.24,0-4-3.28-2.64-3.57,6.22-1.36,8.94-1.5,14.41-4.79a3.727,3.727,0,0,1,1.92-.6",
    fill: "#263238"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7808",
    "data-name": "Caminho 7808",
    d: "M388,84.36c7.37,5.19,9.59,18.55,9.59,18.55l-16.7,8.46a79.664,79.664,0,0,1-6.1-16.57C373,86.9,382.76,80.68,388,84.36",
    fill: "#fdbb4e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13666",
    "data-name": "Grupo 13666",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13665",
    "data-name": "Grupo 13665"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13664",
    "data-name": "Grupo 13664",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7809",
    "data-name": "Caminho 7809",
    d: "M379.65,92.88l6.58,15.76-5.34,2.73a88.981,88.981,0,0,1-4.32-10.32Z"
  }))))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7810",
    "data-name": "Caminho 7810",
    d: "M338.89,119c.06,8.81.59,19.77,1.9,33.37H383c.51-6.2-2.08-35.43,4.21-64.7a3.871,3.871,0,0,0-2.967-4.6c-.074-.016-.148-.029-.223-.041a96.678,96.678,0,0,0-10-1.07,155.782,155.782,0,0,0-17.95,0,70.217,70.217,0,0,0-7.19,1A9.58,9.58,0,0,0,341.5,90a83.7,83.7,0,0,0-2.31,16.45c-.19,3.6-.33,7.77-.3,12.55",
    fill: "#fdbb4e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13669",
    "data-name": "Grupo 13669",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13668",
    "data-name": "Grupo 13668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13667",
    "data-name": "Grupo 13667",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7811",
    "data-name": "Caminho 7811",
    d: "M352.21,102.46c-2.79,2-8.13,3-13,3.41.08-1.29.18-2.51.29-3.66,1.31-.69,2.57-1.32,3.76-1.9Z"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13672",
    "data-name": "Grupo 13672",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13671",
    "data-name": "Grupo 13671"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13670",
    "data-name": "Grupo 13670",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7812",
    "data-name": "Caminho 7812",
    d: "M345.69,334.9l.05,10.16h7.89l-.04-10.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7813",
    "data-name": "Caminho 7813",
    d: "M403.21,328.43l-7.6,1.4,2.82,9.27,7.6-1.4Z"
  }))))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7814",
    "data-name": "Caminho 7814",
    d: "M368,53.22c1.15,7.77,2.22,12.25-.78,17.15a10.18,10.18,0,0,1-18-1c-3.09-6.46-4.46-18.09,2.31-23A10.3,10.3,0,0,1,368,53.22",
    fill: "#1ed6bb"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7815",
    "data-name": "Caminho 7815",
    d: "M351.84,58.9c-2.93-1.29-2.65-5.9-1.76-7.84-3.39,1.16-8.29,1.83-9.17-1.62s2.11-4.55.28-7.5,4-6.16,6.72-2,9.44,2.3,13.78-1.67c3.16-2.89,7.78.84,5.95,4.61,0,0,9.5-.61,7.61,5.84s-4.56,6.67-3.95,11.26c.42,3.1.78,9.4-2.94,10.29-4.5,1.03-15.72-2.96-16.52-11.37",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13675",
    "data-name": "Grupo 13675",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13674",
    "data-name": "Grupo 13674"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13673",
    "data-name": "Grupo 13673",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7816",
    "data-name": "Caminho 7816",
    d: "M351.78,67.31c-.86.62-1.75,1.28-2.66,2l.05.11a10.51,10.51,0,0,0,4.09,4.51c.57-.55.89-2.4,1.95-2.37,3.17.09,9.3-1.24,10.32-4.82Z"
  }))))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7817",
    "data-name": "Caminho 7817",
    d: "M354.25,58.79a9.444,9.444,0,0,1-.76,5.07c-.9,1.83-2.32.66-2.87-1.59-.5-2-.63-5.41.67-6.41s2.71.65,2.96,2.93",
    fill: "#1ed6bb"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7818",
    "data-name": "Caminho 7818",
    d: "M355.77,152.4s6.63,60.32,10.67,82.92c4.43,24.75,27.37,102.43,27.37,102.43l14.14-3S392.16,262.07,390,237.57c-2.31-26.6-7-85.17-7-85.17Z",
    fill: "#fdbb4e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13678",
    "data-name": "Grupo 13678",
    opacity: 0.3,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13677",
    "data-name": "Grupo 13677"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13676",
    "data-name": "Grupo 13676",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7819",
    "data-name": "Caminho 7819",
    d: "M355.77,152.4s6.63,60.32,10.67,82.92c4.43,24.75,27.37,102.43,27.37,102.43l14.14-3S392.16,262.07,390,237.57c-2.2-25.28-2.2-25.23-7-85.17Z"
  }))))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7820",
    "data-name": "Caminho 7820",
    d: "M390.65,333c-.06,0,2.4,5.16,2.4,5.16L409,334.75l-1.13-4.82Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13681",
    "data-name": "Grupo 13681",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13680",
    "data-name": "Grupo 13680"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13679",
    "data-name": "Grupo 13679",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7821",
    "data-name": "Caminho 7821",
    d: "M360.6,173.9c10.28,2,7.69,40.65,5.68,60.52-2.44-14-5.77-41.07-8-60.24a3.491,3.491,0,0,1,2.32-.28"
  }))))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7822",
    "data-name": "Caminho 7822",
    d: "M340.79,152.4s-3.36,59-3.43,83.09c-.08,25,5.5,107,5.5,107h13.38s3.6-80.51,5.14-105.1c1.68-26.81,7.17-85,7.17-85Z",
    fill: "#fdbb4e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13684",
    "data-name": "Grupo 13684",
    opacity: 0.3,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13683",
    "data-name": "Grupo 13683"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13682",
    "data-name": "Grupo 13682",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7823",
    "data-name": "Caminho 7823",
    d: "M340.79,152.4s-3.36,59-3.43,83.09c-.08,25,5.5,107,5.5,107h13.38s3.6-80.51,5.14-105.1c1.68-26.81,7.17-85,7.17-85Z"
  }))))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7824",
    "data-name": "Caminho 7824",
    d: "M340.5,337.18c-.06,0,.54,5.55.54,5.55H357.3l.63-5Z",
    fill: "#263238"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7825",
    "data-name": "Caminho 7825",
    d: "M357.52,96.74c-1.6.15-2.95.24-4.42.28s-2.87.07-4.3.06a78.854,78.854,0,0,1-8.66-.5,66.124,66.124,0,0,1-8.74-1.5,42.59,42.59,0,0,1-8.82-3.13l-.33-.17a5.21,5.21,0,0,1-2.4-6.968l.016-.032a5.423,5.423,0,0,1,.49-.81,28.148,28.148,0,0,1,4.05-4.33c1.35-1.2,2.7-2.27,4.06-3.29,2.72-2.05,5.5-3.86,8.29-5.62s5.64-3.39,8.51-5,5.76-3.06,8.76-4.45a3,3,0,0,1,3.07,5.06c-2.51,1.93-5.1,3.84-7.61,5.8s-5,3.89-7.49,5.87-4.86,4-7.13,6a37.394,37.394,0,0,0-3.19,3.09,20.5,20.5,0,0,0-2.36,2.88l-2.21-8a36.639,36.639,0,0,0,6.72,1.79,70.654,70.654,0,0,0,7.41.86c2.53.16,5.09.25,7.66.25h3.86c1.28,0,2.63-.1,3.75-.16h.13a6,6,0,0,1,.92,11.93Z",
    fill: "#1ed6bb"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7826",
    "data-name": "Caminho 7826",
    d: "M363.12,59.72l-5,1.11s-6.69-.83-8.22,4.21l4,3.38,6.12,1a4.615,4.615,0,0,0,2.83-.46l1.56-.81a2.379,2.379,0,0,0,1.28-1.89l.37-4a2.381,2.381,0,0,0-2.94-2.54",
    fill: "#1ed6bb"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7827",
    "data-name": "Caminho 7827",
    d: "M353.36,102.58c-8.41,2.34-18-.58-18-.58l3.53-18.83s8.35-.74,13.57-.85c13.43-.32,16.06,16.06.9,20.26",
    fill: "#fdbb4e"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRefused);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/refused.141d1d1e1a119a64b0b2baa79ca03ecb.svg";